<template>
  <StIcon
    v-tooltip="thisChannelObj.name"
    :icon-name="thisChannelObj.icon"
    :color="thisChannelObj.color"
    size="30"
    class="ma-3"
  />
</template>

<script>
import StIcon from '@stilingue/st-icon';
import channelModel from '@/mixins/channel-model';

export default {
  name: 'RawChannel',
  components: {
    StIcon,
  },
  mixins: [
    channelModel,
  ],
  props: {
    channel: {
      type: String,
      required: true,
    },
  },
  computed: {
    thisChannelObj() {
      return this.getChannelColorNameAndIcon(this.channel);
    },
  },
};
</script>

<style scoped>
</style>
